import { render, staticRenderFns } from "./posterModel.vue?vue&type=template&id=04bd4723&scoped=true"
import script from "./posterModel.vue?vue&type=script&lang=js"
export * from "./posterModel.vue?vue&type=script&lang=js"
import style0 from "./posterModel.vue?vue&type=style&index=0&id=04bd4723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd4723",
  null
  
)

export default component.exports